import { MAGENTO_LABEL, PRESTASHOP_LABEL, SHOPIFY_LABEL, WOOCOMMERCE_LABEL } from './translations';

// I18N
export const I18N_DEFAULT_LANGUAGE: string = 'en';
export const I18N_SUPPORTED_LANGUAGES: string[] = ['it', 'en'];
export const I18N_DEFAULT_PREFIX_COUNTRY: string = 'IT';
export const I18N_UNKNOWN_FLAG: string = '../../../assets/img/flags/unknown.svg';

// Errors
export const ERROR_UNKNOWN_CODE: string = 'unknown';
export const ERROR_PASSWORD_MISMATCH_CODE: string = 'PasswordConfirmMismatch';
export const ERROR_USER_NOT_FOUND_CODE: string = 'UserNotFoundException';
export const ERROR_USER_NOT_AUTHORIZED_CODE = 'NotAuthorizedException';
export const ERROR_USER_NOT_CONFIRMED_CODE: string = 'UserNotConfirmedException';
export const ERROR_USERNAME_EXISTS_CODE: string = 'UsernameExistsException';
export const ERROR_PSS_RESET_LIMIT_EXC_CODE = 'LimitExceededException';
export const ERROR_NEW_PASSWORD_REQUIRED_CODE = 'NEW_PASSWORD_REQUIRED';
export const ERROR_MFA_REQUIRED_CODE = 'SMS_MFA';
export const ERROR_MFA_SETUP_CODE = 'MFA_SETUP';
export const ERROR_COMPANY_CONTRACT_NOT_FOUND: string = 'CompanyContractNotFound';
export const ERROR_COMPANY_MEMBERSHIP_NOT_FOUND: string = 'CompanyMembershipNotFoundError';
export const ERROR_COMPANY_NOT_FOUND: string = 'CompanyNotFound';
export const ERROR_SELLER_NOT_FOUND: string = 'SellerNotFound';
export const ERROR_STORE_NOT_FOUND: string = 'StoreNotFound';
export const ERROR_ORDER_NOT_FOUND: string = 'OrderNotFoundError';
export const ERROR_BUYER_NOT_FOUND: string = 'BuyerNotFoundError';
export const ERROR_STEP_NOT_FOUND: string = 'StepNotFoundError';
export const ERROR_UNPAID_NOT_FOUND: string = 'UnpaidNotFoundError';
export const ERROR_STRIPE_PS_NOT_FOUND_CODE: string = 'StripePaymentSourceNotFoundError';
export const ERROR_QINETIC_PS_NOT_FOUND_CODE: string = 'CompanyQineticPaymentSourceNotFound';
export const ERROR_STORE_QINETIC_PS_NOT_FOUND_CODE: string = 'StoreQineticPaymentSourceNotFound';
export const ERROR_STORE_MEMBERHIPS_NOT_FOUND_CODE: string = 'StoreMembershipNotFoundError';
export const ERROR_ADMIN_ROLE_PERMISSION_CODE: string = 'AdminRolePermissionError';
export const ERROR_BUYER_PAYMENT_SOURCE_REMOVE_CODE: string = 'BuyerStripePaymentSourceRemoveError';
export const ERROR_STORE_BULK_CREATE_LIMIT_CODE: string = 'StoreBulkCreateLimit';
export const ERROR_STORE_INCONSISTENT_COMPANY_ID_CODE: string = 'StoreInconsistentCompanyID';
export const ERROR_STRIPE_PAYMENT_SOURCES_NOT_FOUND_CODE: string = 'BuyerStripePaymentSourceNotFoundError';
export const ERROR_QINETIC_PAYMENT_SOURCES_NOT_FOUND_CODE: string = 'BuyerQineticPaymentSourceNotFoundError';
export const ERROR_LONG_NOT_ENABLED_CODE: string = 'LongNotEnabled';
export const ERROR_BUYER_DOCUMENT_NOT_FOUND_CODE: string = 'BuyerDocumentNotFoundError';
export const ERROR_COMPANY_DISABLED_CODE = 'CompanyDisabledError';
export const ERROR_COMPANY_PARTIALLY_ENABLED_CODE = 'CompanyPartiallyEnabledError';
export const ERROR_CORRUPTED_FILE_CODE = 'CorruptedFile';
export const ERROR_COMPANY_CONTRACT_WITHOUT_SALES_NETWORK_CODE = 'CompanyContractWithoutSalesNetwork';
export const ERROR_COMPANY_BNPL_LONG_DISABLED_CODE = 'CompanyBnplLongDisabledError';
export const ERROR_STORE_BNPL_MIN_AMOUNT_OUT_OF_COMPANY_RANGE_CODE = 'StoreBnplMinAmountOutOfCompanyRangeError';
export const ERROR_STORE_BNPL_MAX_AMOUNT_OUT_OF_COMPANY_RANGE_CODE = 'StoreBnplMaxAmountOutOfCompanyRangeError';
export const ERROR_VOP_REQUEST_NOT_FOUND: string = 'VopRequestNotFound';
export const ERROR_PRODUCT_CATEGORY_NAME_ALREADY_EXISTS_CODE: string = 'ProductCategoryNameAlreadyExistsError';
export const ERROR_PRODUCT_SUBCATEGORY_NAME_ALREADY_EXISTS_CODE: string = 'ProductSubcategoryNameAlreadyExistsError';
export const ERROR_PRODUCT_CATEGORY_DECIDO_CODE_ALREADY_EXISTS_CODE: string =
  'ProductCategoryDecidoEvaluationCodeAlreadyExistsError';

// Local
export const LOCAL_NAVBAR_STATUS_KEY: string = 'navbar_status';
export const LOCAL_USERNAME_KEY: string = 'username';

// Colors
export const COLOR_PRIMARY_500: string = '#3d4e66';
export const COLOR_PRIMARY_CONTRAST_500: string = '#ffebde';
export const COLOR_ACCENT_500: string = '#ab5998';
export const COLOR_ACCENT_CONTRAST_500: string = '#fff6f5';

// Tables
export const COMPANIES_TABLE_COLUMNS: string[] = [
  'company_id',
  'business_name',
  'status',
  'created_at',
  //'owner_id',
  //'owner_email',
  //'vat',
  'sales_network_id',
  'product_category',
  //'revenues',
  //'website',
  //'custom_subdomain',
  'agreement',
  'origin',
  'sales_reference_email',
  //'custom_subdomain',
  'actions',
];

export const ARCHIVED_COMPANIES_TABLE_COLUMNS: string[] = [
  'company_id',
  'business_name',
  'status',
  'created_at',
  'owner_id',
  'owner_email',
  'vat',
  'sales_network_id',
  'revenues',
  'website',
  'actions',
];

export const SELLERS_TABLE_COLUMNS: string[] = [
  'seller_id',
  'created_at',
  'last_login',
  'name',
  'company_business_name',
  'phone',
  'email',
  'is_confirmed',
  //'mfa',
  'actions',
];

export const STORE_DETAILS_TEAM_TABLE_COLUMNS: string[] = [
  'seller_id',
  'created_at',
  'name',
  'email',
  'role',
  'actions',
];

export const SELLER_DETAILS_STORES_TABLE_COLUMNS: string[] = ['store_id', 'logo', 'name', 'seller_role', 'actions'];

export const BUYER_DETAILS_ORDERS_TABLE_COLUMNS: string[] = [
  'order_id',
  'created_at',
  'buyer',
  'store',
  'amount',
  'status',
  'tax_deduction',
  'completed_at',
  'qinetic',
  'instalments',
  'BD1',
  'BD2',
  'BD5',
  'actions',
];

export const STORE_DETAILS_ORDERS_TABLE_COLUMNS: string[] = [
  'order_id',
  'created_at',
  'buyer',
  //'store',
  'amount',
  'status',
  'tax_deduction',
  'completed_at',
  'qinetic',
  'instalments',
  'BD1',
  'BD2',
  'BD5',
  'actions',
];

export const COMPANY_DETAILS_ORDERS_TABLE_COLUMNS: string[] = [
  'order_id',
  'created_at',
  'buyer',
  'store',
  'amount',
  'status',
  'tax_deduction',
  'completed_at',
  'qinetic',
  'instalments',
  'BD1',
  'BD2',
  'BD5',
  'actions',
];

export const PENDING_INVITATIONS_TABLE_COLUMNS: string[] = [
  'sender_email',
  'recipient_email',
  'company_id',
  'company_business_name',
  'stores',
  'recipient_role',
  'created_at',
];

export const BUYERS_TABLE_COLUMNS: string[] = [
  'buyer_id',
  'created_at',
  //'last_login',
  'origin',
  'name',
  'phone',
  //'email',
  'current_login_attempts',
  'is_confirmed',
  'on_boarding_steps',
  'lock',
  'status',
  'actions',
];

export const STEPS_TABLE_COLUMNS: string[] = [
  'order_id',
  'index',
  'qinetic',
  'buyer',
  'amount',
  'due_date',
  'payment_date',
  'created_at',
  'status',
  'step_id',
  'actions',
];

export const UNPAID_TABLE_COLUMNS: string[] = [
  'order_id',
  'step_id',
  'company_name',
  'store_name',
  'index',
  'unpaid_from',
  'days_unpaid',
  'attempts_counter',
  'unpaid',
  'qinetic',
  'buyer',
  'buyer_fullname',
  'amount',
  'due_date',
  'step_created_at',
  'recovered_at',
  'status',
  'actions',
];

export const STORES_TABLE_COLUMNS: string[] = [
  'store_id',
  'logo',
  'name',
  'status',
  'company_business_name',
  'sales_network_id',
  'created_at',
  'store_type',
  /*'company_vat',
  'phone',
  'email',
  'address',
  'city',
  'postal_code',
  'cms',
  'min_amount',
  'max_amount',
  'custom_subdomain',*/
  'agreement',
  'actions',
];

export const ORDERS_TABLE_COLUMNS: string[] = [
  'order_id',
  'last_status_change',
  'last_status_change_at',
  'liquidated_at',
  'qinetic',
  'is_looked_at',
  'buyer',
  //'amount',
  'instalments',
  'payment_source',
  'status',
  'store',
  //'seller_email',
  //'BD1',
  //'BD2',
  //'BD5',
  //'channel',
  'origin',
  'tax_deduction',
  //'tax_deduction_type',
  //'ext_order_id',
  //'tax_deduction_invoice_number',
  //'tax_deduction_invoice_date',
  //'ready_for_liquidation_at',
  //'fee',
  //'net',
  //'merchant_refund',
  'agreement',
  //'payment_link',
  'created_at',
  'completed_at',
  'pre_authorization_at',
  'actions',
];

export const VOP_REQUEST_TABLE_COLUMNS: string[] = [
  'vop_request_id',
  'created_at',
  'status',
  'result',
  'similiarity_score',
  'most_similar_call',
  'beneficiary_firstname',
  'beneficiary_lastname',
  'beneficiary_tax_code',
  'beneficiary_iban',
  'buyer_id',
  'order_id',
  'actions',
];

export const SETTINGS_TABLE_COLUMNS: string[] = ['setting', 'actions'];

export const PRODUCT_CATEGORY_TABLE_COLUMNS: string[] = [
  'product_category_id',
  'name',
  'decido_evaluation_code',
  'created_at',
  'actions',
];

export const PRODUCT_SUBCATEGORY_TABLE_COLUMNS: string[] = ['sub_category_id', 'name', 'ecommerce_default', 'actions'];

export const CLUSTER_TABLE_COLUMNS: string[] = [
  'cluster_code',
  'steps_number',
  'max_tan',
  'valid_from',
  'valid_to',
  'actions',
];

export const PLUGIN_SUPPORTED_CMS = [
  {
    value: 'woocommerce',
    label: WOOCOMMERCE_LABEL,
  },
  {
    value: 'prestashop',
    label: PRESTASHOP_LABEL,
  },
  {
    value: 'magento',
    label: MAGENTO_LABEL,
  },
  {
    value: 'shopify',
    label: SHOPIFY_LABEL,
  },
];

// IMGs
export const LOGO_PLACEHOLDER_SRC: string = '../../../assets/img/logo/sp-logo-placeholder.png';

// Stages
export const PROD_STAGE: string = 'prod';
export const COLL_STAGE: string = 'coll';
export const DEV_STAGE: string = 'dev';

// Buyer app references
export const BUYER_APP_LOCAL_URL: string = 'http://localhost:6001/#/auth/signin';
export const BUYER_APP_DEV_URL: string = 'https://buyers.dev.splittypay.com/#/auth/signin';
export const BUYER_APP_COLL_URL: string = 'https://buyers.coll.splittypay.com/#/auth/signin';
export const BUYER_APP_PROD_URL: string = 'https://buyers.splittypay.com/#/auth/signin';

// API params
export const DEFAULT_GET_LIMIT: number = 30;

export enum ProductCategoryType {
  PRODUCT_CATEGORY_CLOTHING = 'clothing',
  PRODUCT_CATEGORY_REAL_ESTATE_AGENCIES = 'real_estate_agencies',
  PRODUCT_CATEGORY_HEARING_AIDS = 'hearing_aids',
  PRODUCT_CATEGORY_FURNITURE = 'furniture',
  PRODUCT_CATEGORY_HOME_AND_BATHROOM_FURNITURE = 'home_and_bathroom_furniture',
  PRODUCT_CATEGORY_MUSICAL_INSTRUMENTS = 'musical_instruments',
  PRODUCT_CATEGORY_SPORTING_GOODS = 'sporting_goods',
  PRODUCT_CATEGORY_INSURANCE = 'insurance',
  PRODUCT_CATEGORY_BICYCLES = 'bicycles',
  PRODUCT_CATEGORY_BODYWORK = 'bodywork',
  PRODUCT_CATEGORY_FURNITURE_ACCESSORIES = 'furniture_accessories',
  PRODUCT_CATEGORY_DEALERS = 'dealers',
  PRODUCT_CATEGORY_COSMETICS_BEAUTY = 'cosmetics_beauty',
  PRODUCT_CATEGORY_DOOR_TO_DOOR = 'door_to_door',
  PRODUCT_CATEGORY_DIY_AND_HOME_IMPROVEMENT = 'diy_and_home_improvement',
  PRODUCT_CATEGORY_PHYSIOTHERAPY_OSTEOPATHY = 'physiotherapy_osteopathy',
  PRODUCT_CATEGORY_TRAINING_AND_COURSES = 'training_and_courses',
  PRODUCT_CATEGORY_TIRE_DEALERS = 'tire_dealers',
  PRODUCT_CATEGORY_HOME_ALARM_SYSTEMS = 'home_alarm_systems',
  PRODUCT_CATEGORY_CAR_ALARM_SYSTEMS = 'car_alarm_systems',
  PRODUCT_CATEGORY_CAR_MOTORCYCLE_REPAIR_SHOPS = 'car_motorcycle_repair_shops',
  PRODUCT_CATEGORY_OPTICIANS = 'opticians',
  PRODUCT_CATEGORY_GYMS = 'gyms',
  PRODUCT_CATEGORY_BED_BASES_AND_MATTRESSES = 'bed_bases_and_mattresses',
  PRODUCT_CATEGORY_ENERGY_RENOVATION = 'energy_renovation',
  PRODUCT_CATEGORY_DOORS_AND_WINDOWS = 'doors_and_windows',
  PRODUCT_CATEGORY_PROFESSIONAL_SERVICES = 'professional_services',
  PRODUCT_CATEGORY_DENTAL_CLINICS = 'dental_clinics',
  PRODUCT_CATEGORY_MEDICAL_PRACTICES = 'medical_practices',
  PRODUCT_CATEGORY_VETERINARIANS = 'veterinarians',
  PRODUCT_CATEGORY_STOVES_AND_FIREPLACES = 'stoves_and_fireplaces',
  PRODUCT_CATEGORY_LEISURE = 'leisure',
  PRODUCT_CATEGORY_TV_TELEPHONY_AND_ELECTRONICS = 'tv_telephony_and_electronics',
  PRODUCT_CATEGORY_OTHER = 'other',
}

export enum OriginType {
  ORIGIN_LOANS = 'loans',
  ORIGIN_MTP = 'mtp',
  ORIGIN_DIRECT = 'direct',
}

export enum ReportType {
  COMPANY = 'company',
  SELLER = 'seller',
  STORE = 'store',
  UNPAID = 'unpaid',
  ORDER = 'order',
  BUYER = 'buyer',
  VOP_REQUEST = 'vop_request',
}

export const WOOCOMMERCE_PRODUCT_PREVIEW_POSITION_LABELS: { [key: string]: string } = {
  woocommerce_before_single_product: 'HOOKS.WOOCOMMERCE.BEFORE_SINGLE_PRODUCT',
  woocommerce_before_single_product_summary: 'HOOKS.WOOCOMMERCE.BEFORE_SINGLE_PRODUCT_SUMMARY',
  woocommerce_single_product_summary: 'HOOKS.WOOCOMMERCE.SINGLE_PRODUCT_SUMMARY',
  woocommerce_before_add_to_cart_form: 'HOOKS.WOOCOMMERCE.BEFORE_ADD_TO_CART_FORM',
  woocommerce_before_variations_form: 'HOOKS.WOOCOMMERCE.BEFORE_VARIATIONS_FORM',
  woocommerce_before_add_to_cart_button: 'HOOKS.WOOCOMMERCE.BEFORE_ADD_TO_CART_BUTTON',
  woocommerce_before_single_variation: 'HOOKS.WOOCOMMERCE.BEFORE_SINGLE_VARIATION',
  woocommerce_single_variation: 'HOOKS.WOOCOMMERCE.SINGLE_VARIATION',
  woocommerce_before_add_to_cart_quantity: 'HOOKS.WOOCOMMERCE.BEFORE_ADD_TO_CART_QUANTITY',
  woocommerce_after_add_to_cart_quantity: 'HOOKS.WOOCOMMERCE.AFTER_ADD_TO_CART_QUANTITY',
  woocommerce_after_single_variation: 'HOOKS.WOOCOMMERCE.AFTER_SINGLE_VARIATION',
  woocommerce_after_add_to_cart_button: 'HOOKS.WOOCOMMERCE.AFTER_ADD_TO_CART_BUTTON',
  woocommerce_after_variations_form: 'HOOKS.WOOCOMMERCE.AFTER_VARIATIONS_FORM',
  woocommerce_after_add_to_cart_form: 'HOOKS.WOOCOMMERCE.AFTER_ADD_TO_CART_FORM',
  woocommerce_product_meta_start: 'HOOKS.WOOCOMMERCE.PRODUCT_META_START',
  woocommerce_product_meta_end: 'HOOKS.WOOCOMMERCE.PRODUCT_META_END',
  woocommerce_share: 'HOOKS.WOOCOMMERCE.SHARE',
  woocommerce_after_single_product_summary: 'HOOKS.WOOCOMMERCE.AFTER_SINGLE_PRODUCT_SUMMARY',
  woocommerce_after_single_product: 'HOOKS.WOOCOMMERCE.AFTER_SINGLE_PRODUCT',
};

export const WOOCOMMERCE_CART_PREVIEW_LABELS: { [key: string]: string } = {
  woocommerce_before_cart: 'HOOKS.WOOCOMMERCE.BEFORE_CART',
  woocommerce_before_cart_table: 'HOOKS.WOOCOMMERCE.BEFORE_CART_TABLE',
  woocommerce_before_cart_contents: 'HOOKS.WOOCOMMERCE.BEFORE_CART_CONTENTS',
  woocommerce_cart_contents: 'HOOKS.WOOCOMMERCE.CART_CONTENTS',
  woocommerce_cart_coupon: 'HOOKS.WOOCOMMERCE.CART_COUPON',
  woocommerce_after_cart_contents: 'HOOKS.WOOCOMMERCE.AFTER_CART_CONTENTS',
  woocommerce_after_cart_table: 'HOOKS.WOOCOMMERCE.AFTER_CART_TABLE',
  woocommerce_cart_collaterals: 'HOOKS.WOOCOMMERCE.CART_COLLATERALS',
  woocommerce_before_cart_totals: 'HOOKS.WOOCOMMERCE.BEFORE_CART_TOTALS',
  woocommerce_cart_totals_before_shipping: 'HOOKS.WOOCOMMERCE.CART_TOTALS_BEFORE_SHIPPING',
  woocommerce_before_shipping_calculator: 'HOOKS.WOOCOMMERCE.BEFORE_SHIPPING_CALCULATOR',
  woocommerce_after_shipping_calculator: 'HOOKS.WOOCOMMERCE.AFTER_SHIPPING_CALCULATOR',
  woocommerce_cart_totals_after_shipping: 'HOOKS.WOOCOMMERCE.CART_TOTALS_AFTER_SHIPPING',
  woocommerce_cart_totals_before_order_total: 'HOOKS.WOOCOMMERCE.CART_TOTALS_BEFORE_ORDER_TOTAL',
  woocommerce_cart_totals_after_order_total: 'HOOKS.WOOCOMMERCE.CART_TOTALS_AFTER_ORDER_TOTAL',
  woocommerce_proceed_to_checkout: 'HOOKS.WOOCOMMERCE.PROCEED_TO_CHECKOUT',
  woocommerce_after_cart_totals: 'HOOKS.WOOCOMMERCE.AFTER_CART_TOTALS',
  woocommerce_after_cart: 'HOOKS.WOOCOMMERCE.AFTER_CART',
};

export const PRESTASHOP_PRODUCT_PREVIEW_POSITION_LABELS: { [key: string]: string } = {
  displayProductActions: 'HOOKS.PRESTASHOP.PRODUCT_ACTIONS',
  displayProductAdditionalInfo: 'HOOKS.PRESTASHOP.PRODUCT_ADDITIONAL_INFO',
  displayAfterProductThumbs: 'HOOKS.PRESTASHOP.AFTER_PRODUCT_THUMBS',
  displayReassurance: 'HOOKS.PRESTASHOP.REASSURANCE',
  displayLeftColumnProduct: 'HOOKS.PRESTASHOP.LEFT_COLUMN_PRODUCT',
  displayRightColumnProduct: 'HOOKS.PRESTASHOP.RIGHT_COLUMN_PRODUCT',
  displayFooterProduct: 'HOOKS.PRESTASHOP.FOOTER_PRODUCT',
  displayCardModalContent: 'HOOKS.PRESTASHOP.CARD_MODAL_CONTENT',
  displayCardModalFooter: 'HOOKS.PRESTASHOP.CARD_MODAL_FOOTER',
};

export const PRESTASHOP_CART_PREVIEW_LABELS: { [key: string]: string } = {
  displayShoppingCart: 'HOOKS.PRESTASHOP.SHOPPING_CART',
  displayCartExtraProductActions: 'HOOKS.PRESTASHOP.EXTRA_PRODUCT_ACTIONS',
  displayReassurance: 'HOOKS.PRESTASHOP.REASSURANCE',
  displayShoppingCartFooter: 'HOOKS.PRESTASHOP.SHOPPING_CART_FOOTER',
  displayCrossSellingShoppingCart: 'HOOKS.PRESTASHOP.CROSS_SELLING_SHOPPING_CART',
};

export const MAGENTO_PRODUCT_PREVIEW_POSITION_LABELS: { [key: string]: string } = {
  'splittypay.pdp.main': 'HOOKS.MAGENTO.PDP_MAIN',
  'splittypay.pdp.extrahint': 'HOOKS.MAGENTO.PDP_EXTRAHINT',
};

export const MAGENTO_CART_PREVIEW_LABELS: { [key: string]: string } = {
  'splittypay.cart.summary': 'HOOKS.MAGENTO.CART_SUMMARY',
  'splittypay.cart.totals': 'HOOKS.MAGENTO.CART_TOTALS',
  'splittypay.cart.form': 'HOOKS.MAGENTO.CART_FORM',
};

export enum LastStatusChangeType {
  CREATED_AT = 'created_at',
  BUYER_STRIPE_PAYMENT_SOURCE = 'buyer_stripe_payment_source',
  PRE_AUTHORIZATION_AT = 'pre_authorization_at',
  EXPERIAN_VERIFICATION = 'last_experian_verification_id',
  FEA_CONTRACT_ID = 'fea_contract_id',
  CONTRACT_ID = 'contract_id',
  COMPLETED_AT = 'completed_at',
  CANCELED_AT = 'canceled_at',
  REFUNDED_AT = 'refunded_at',
  READY_FOR_LIQUIDATION_AT = 'ready_for_liquidation_at',
  RUNNING_AT = 'running_at',
  PENDING_AT = 'pending_at',
}

export const PRODUCT_CATEGORY_DEFAULT_INSTALLMENT_PLAN: number[] = [4, 6, 8, 10, 12];
